import { Route } from '@angular/router';

import { authGuard } from '@rent2end/core/auth';
import { translationGuard } from '@rent2end/core/translation';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./navigation/app-navigation.component'),
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.component'),
        canActivate: [authGuard, translationGuard('dashboard', 'profile', 'estates', 'rents', 'settlements')]
      },
      {
        path: 'estates',
        loadChildren: () => import('./estates/estates.routes'),
        canActivate: [authGuard, translationGuard('estates')],
      },
      {
        path: 'rents',
        loadChildren: () => import('./rents/rents.routes'),
        canActivate: [authGuard, translationGuard('rents', 'profile', 'estates')],
      },
      {
        path: 'settlements',
        loadChildren: () => import('./settlements/settlements.routes'),
        canActivate: [authGuard, translationGuard('rents', 'settlements')],
      },
      {
        path: 'faults',
        loadChildren: () => import('./faults/faults.routes'),
        canActivate: [authGuard, translationGuard('faults', 'rents')],
      },
      {
        path: 'purchases',
        loadChildren: () => import('./purchases/purchases.routes'),
        canActivate: [authGuard, translationGuard('purchases', 'rents')],
      },
      {
        path: 'documents',
        loadChildren: () => import('./documents/documents.routes'),
        canActivate: [authGuard, translationGuard('documents')],
      },
      {
        path: 'services',
        loadChildren: () => import('./services/services.routes'),
        canActivate: [authGuard, translationGuard('services')],
      },
      {
        path: 'epc',
        loadChildren: () => import('./epc/epc.routes'),
        canActivate: [authGuard, translationGuard('epc', 'estates')],
      },
      {
        path: 'profile',
        loadComponent: () => import('./profile/profile.component'),
        canActivate: [authGuard, translationGuard('profile')],
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  { path: 'auth', loadChildren: () => import('./auth/auth.routes') },
  { path: '**', redirectTo: '' },
];
